import { render, staticRenderFns } from "./AddRoleCard.vue?vue&type=template&id=11877a0e&scoped=true&"
import script from "./AddRoleCard.vue?vue&type=script&lang=js&"
export * from "./AddRoleCard.vue?vue&type=script&lang=js&"
import style0 from "./AddRoleCard.vue?vue&type=style&index=0&id=11877a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11877a0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
